/* istanbul ignore file */
import React from 'react';
import BreadcrumbItem from './BreadcrumbItem';
import type { EntityBreadcrumbItemProps } from '../BreadcrumbsTypes';

const ListBreadcrumbItem = ({ entity, ...props }: EntityBreadcrumbItemProps) => {
  return <BreadcrumbItem {...props}>{entity}</BreadcrumbItem>;
};

export default ListBreadcrumbItem;
